export default "__VITE_ASSET__lHf4S0nw__"